<template>
    <Teleport to="body">
        <Modal ref="documentViewerModal" title="Document Viewer" :backdrop="false" custom-class="modal-xl" :disabled="true">
            <template #form>
                <div v-if="loading" class="d-flex justify-content-center">
                    <i class="spinner-border" />
                </div>
                <vue-pdf-embed
                    v-if="pdfSource"
                    :source="pdfSource"
                    @loaded="onPdfLoadComplete"
                />
                <img class="embed-image" v-if="imageSource" :src="imageSource" />
                <video class="embed-image" v-if="videoSource" controls>
                    <source :src="videoSource" type="video/mp4" />
                </video>
                <embed class="embed-office" :src="officeSource" v-if="officeSource" />
                <div v-if="miscSource" class="alert alert-warning">This file type cannot be previewed.</div>
            </template>
        </Modal>
    </Teleport>
</template>

<script>
import Modal from './Modal.vue';
import VuePdfEmbed from 'vue-pdf-embed';

export default {
    name: 'DocumentViewer',
    components: {
        Modal,
        VuePdfEmbed,
    },
    data() {
        return {
            loading: false,
            pdfSource: null,
            imageSource: null,
            videoSource: null,
            officeSource: null,
            miscSource: null,
        }
    },
    expose: ['onView'],
    methods: {
        onView(url) {
            this.$refs.documentViewerModal.show();

            this.pdfSource = null;
            this.imageSource = null;
            this.officeSource = null;
            this.miscSource = null;
            this.videoSource = null;
            this.loading = true;

            let fileType = url;
            if (url?.split) {
                fileType = url?.split('?')?.[0];
            }
            
            if (fileType?.toLowerCase().indexOf('.pdf') > -1) {
                setTimeout(() => {
                    this.pdfSource = url;
                }, 500);
            } else if (
                fileType?.toLowerCase().indexOf('.jpg') > -1 ||
                fileType?.toLowerCase().indexOf('.jpeg') > -1 ||
                fileType?.toLowerCase().indexOf('.gif') > -1 ||
                fileType?.toLowerCase().indexOf('.png') > -1
            ) {
                this.imageSource = url;
                this.loading = false;
            } else if (
                fileType?.toLowerCase().indexOf('.doc') > -1 ||
                fileType?.toLowerCase().indexOf('.xls') > -1
            ) {
                this.officeSource = `https://docs.google.com/gview?url=${encodeURIComponent(
                url
                )}&embedded=true`;
                this.loading = false;
            } else if (fileType?.toLowerCase().indexOf('.xml') > -1) {
                this.xmlSource = url;
                this.loading = false;
            } else if (fileType?.toLowerCase().indexOf('.mp4') > -1) {
                this.videoSource = url;
                this.loading = false;
            } else {
                this.miscSource = true;
                this.loading = false;
            }
        },
        onPdfLoadComplete() {
            this.loading = false;
        },
    },
}
</script>

<style scoped>
.embed-image {
  width: 100%;
}

.embed-office {
  width: 100%;
  min-height: 500px;
}

.vue-pdf-embed {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  width: calc(100% + 1px);
}
</style>